'use client';

import { Star } from 'lucide-react';
import { useGoogleReviews } from '@/hooks/useGoogleReviews';

function Stars({ rating }: { rating: number }) {
  return (
    <span className="reviews-stars" aria-hidden="true">
      {Array.from({ length: 5 }).map((_, i) => (
        <Star key={i} size={14} fill={i < Math.round(rating) ? 'currentColor' : 'none'} strokeWidth={1.5} />
      ))}
    </span>
  );
}

export function GoogleReviewsSection({ d }: { d: (ms: string) => React.CSSProperties }) {
  const { data, isLoading, isError } = useGoogleReviews();
  const placeId = process.env.NEXT_PUBLIC_GOOGLE_PLACE_ID;

  if (isError || (!isLoading && (!data || data.reviews.length === 0))) {
    return null;
  }

  return (
    <div className="reviews-stage">
      <div className="reviews-head">
        <div>
          <span className="eyebrow fade-up" style={d('0ms')}>Ce spun clienții</span>
          <h2 className="reviews-title lines" style={{ marginTop: '18px' }}>
            <span className="line"><span style={d('100ms')}>Păreri</span></span>
            <span className="line"><span style={d('280ms')}>de pe <em>Google</em>.</span></span>
          </h2>
        </div>

        {!isLoading && data && (
          <div className="reviews-score fade-up" style={d('450ms')}>
            <span className="reviews-score-num">{data.rating.toFixed(1)}</span>
            <div className="reviews-score-meta">
              <Stars rating={data.rating} />
              <span className="reviews-count">{data.userRatingCount} recenzii Google</span>
            </div>
          </div>
        )}
      </div>

      {isLoading ? (
        <div className="reviews-grid">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="review-card" style={{ opacity: 0.5 }}>
              <div className="review-card-text">Se încarcă recenziile...</div>
            </div>
          ))}
        </div>
      ) : (
        <div className="reviews-grid">
          {data!.reviews.slice(0, 3).map((review, i) => (
            <div key={`${review.authorName}-${i}`} className="review-card fade-up" style={d(`${600 + i * 120}ms`)}>
              <Stars rating={review.rating} />
              {review.text && <p className="review-card-text">&ldquo;{review.text}&rdquo;</p>}
              <div className="review-card-author">
                {review.profilePhotoUrl ? (
                  // eslint-disable-next-line @next/next/no-img-element
                  <img src={review.profilePhotoUrl} alt="" className="review-card-avatar" />
                ) : (
                  <div className="review-card-avatar" />
                )}
                <div>
                  <div className="review-card-name">{review.authorName}</div>
                  <div className="review-card-time">{review.relativeTime}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {placeId && (
        <a
          className="reviews-cta fade-up"
          style={d('950ms')}
          href={`https://search.google.com/local/writereview?placeid=${placeId}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Vezi toate recenziile pe Google →
        </a>
      )}
    </div>
  );
}
